import { render, staticRenderFns } from "./OrdersBulkPaymentInfo.vue?vue&type=template&id=a2a7f5e6&scoped=true&"
import script from "./OrdersBulkPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./OrdersBulkPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrdersBulkPaymentInfo.vue?vue&type=style&index=0&id=a2a7f5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a7f5e6",
  null
  
)

export default component.exports